import { render } from "./OsdLeseverstehen.vue?vue&type=template&id=a25c7ff2&scoped=true"
import script from "./OsdLeseverstehen.vue?vue&type=script&lang=js"
export * from "./OsdLeseverstehen.vue?vue&type=script&lang=js"

import "./OsdLeseverstehen.vue?vue&type=style&index=0&id=a25c7ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25c7ff2"]])

export default __exports__